import { CheckCircle2, Download, Printer, Send } from 'lucide-react';

export default function InvoiceActionBar({
  mailbox,
  call,
  onPrint,
  onDownload,
  onFinalize,
  onSend,
  isFinalizing,
  isSending,
  isBusy
}) {
  return (
    <div
      className="flex-shrink-0 px-4 py-3 border-t border-surface-border bg-surface flex items-center gap-2 flex-wrap"
      data-tour-id="invoicing-action-bar"
    >
      {mailbox !== 'cspire' && (
        <>
          <button type="button" className="btn-secondary btn-sm" onClick={onPrint} disabled={isBusy}>
            <Printer className="h-3.5 w-3.5 mr-1" />
            Print
          </button>
          <button type="button" className="btn-secondary btn-sm" onClick={onDownload} disabled={isBusy}>
            <Download className="h-3.5 w-3.5 mr-1" />
            Download PDF
          </button>
        </>
      )}

      <button
        type="button"
        className="btn-primary btn-sm"
        onClick={onFinalize}
        disabled={isFinalizing || call.isFinalized}
      >
        <CheckCircle2 className="h-3.5 w-3.5 mr-1" />
        {call.isFinalized ? 'Finalized' : 'Mark Finalized'}
      </button>

      {mailbox === 'franklin' && (
        <button type="button" className="btn-secondary btn-sm" onClick={onSend} disabled={isSending}>
          <Send className="h-3.5 w-3.5 mr-1" />
          {isSending ? 'Sending...' : 'Send'}
        </button>
      )}
    </div>
  );
}
